import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { Toast, showErrorToUser, useForm } from '@pletly/ui';

import { useAddToOrganisationImportRequestMutation } from './__generated__/importRequest.mutation.generated';

const formSchema = z.object({
	username: z.string(),
});

export const useCareReceiverImport = (organisationUuid: string) => {
	const { t } = useTranslation();
	const formMethods = useForm(formSchema);
	const [sendAddToOrganisationRequest, { loading }] = useAddToOrganisationImportRequestMutation();

	const handleImport = async ({ username: toUsername }: z.infer<typeof formSchema>) => {
		if (loading) {
			return;
		}

		try {
			await sendAddToOrganisationRequest({
				variables: {
					organisationUuid,
					toUsername,
				},
			});

			formMethods.reset({ username: '' });

			return Toast.show({
				text1: t('request-sent'),
				text2: t('request-has-been-sent-to-the-care-receiver-guardian'),
				type: 'success',
			});
		} catch (error) {
			showErrorToUser(error as unknown as Error);
		}
	};

	const onSubmit = formMethods.handleSubmit(handleImport);

	return { formMethods, loading, onSubmit };
};
